<div class="container-fluid" [class.footer-flush]="flush()">
  <footer class="footer">
    <div class="row align-items-center justify-content-between footer-row footer-inner">
      <div class="col-6 footer-copyright-col">
        <div class="copyright text-left">
          <span style="color: #000;" class="font-weight-normal">&copy; {{ currentDate | date: "yyyy" }}</span>
          <a
            href="https://https://www.bestinc.com.ph/"
            class="font-weight-bold ml-1 font-bricolage"
            target="_blank"
            style="color: #000;"
            >Backend Solutions and Technology Inc.</a
          >
        </div>
      </div>
      <div class="col-6 footer-nav-col">
        <ul class="nav nav-footer justify-content-end">
          <li class="nav-item">
            <a
              href="https://https://www.bestinc.com.ph/"
              class="nav-link font-weight-700 font-agrandir"
              target="_blank"
              style="color: rgba(0, 0, 0, 0.6) !important;"
              >Backend Solutions and Technology Inc.</a
            >
          </li>
        </ul>
      </div>
    </div>
  </footer>
</div>